<template>
<div>
  <div class="mod-bar">主体信息：</div>
  <el-form :model="createForm" ref="createForm" label-width="180px" >
    <el-form-item 
      label="主体名称：" 
      prop="subjectName"
      :rules="[
        { required: (type === 1 || isEdit) ? false : true, message: '请输入主体名称', trigger: 'blur' }
      ]"
    >
      <span v-if="isEdit">{{ fzzhtMemberInfo.principalName || '-'}}</span>
      <span v-else-if="type === 1">{{ createForm.subjectName || '-'}}</span>
      <el-input
        v-else
        style="width: 450px" 
        size="small"
        v-model="createForm.subjectName"
        placeholder="请输入主体名称"
      ></el-input>
    </el-form-item>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item 
          label="主体类型：" 
          prop="subjectType"
          :rules="[
            { required: (type === 1 || isEdit) ? false : true, message: '请选择主体类型', trigger: 'change' }
          ]"
        >
          <span v-if="isEdit">{{ detail.principalTypeStr || '-' }}</span>
          <span v-else-if="type == 1">企业</span>
          <el-select v-else v-model="createForm.subjectType" placeholder="请选择" size="small">
            <el-option
              v-for="item in subjectTypeData"
              :key="item.categoryId"
              :label="item.categoryName"
              :value="item.categoryId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="营业执照号：">
          <span v-if="isEdit">{{ fzzhtMemberInfo.businessLicenseNo || '-' }}</span>
          <span v-else-if="type == 1">{{ createForm.businessLicenseNumber || '-' }}</span>
          <el-input
            v-else
            size="small"
            v-model="createForm.businessLicenseNumber"
            placeholder="请输入营业执照号"
          ></el-input>
        </el-form-item>
        <el-form-item label="主体/负责人身份证号：">
          <span v-if="isEdit">{{ fzzhtMemberInfo.responsiblePersonIdNumber || '-' }}</span>
          <span v-else-if="type == 1">无</span>
          <el-input
            v-else
            size="small"
            v-model="createForm.idNumber"
            placeholder="请输入主体/负责人身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="type === 1 || isEdit"
          label="注册手机号：" 
        >
          <span v-if="isEdit">{{ fzzhtMemberInfo.registerMobileNumber || '无' }}</span>
          <span v-if="type === 1">{{ companyInfo.user_cellphone || '-' }}</span>
        </el-form-item>
        <el-form-item label="商品标签：">
          <el-input
            size="small"
            v-model="createForm.goodsTag"
            placeholder="请输入商品标签"
          ></el-input>
        </el-form-item>
        <el-form-item label="业务范围：">
          <el-input
            size="small"
            v-model="createForm.businessScope"
            placeholder="请输入业务范围"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item 
          label="来源：" 
          prop="resource"
          :rules="[
            { required: (type === 1 || isEdit) ? false : true, message: '请选择来源', trigger: 'change' }
          ]"
        >
          <span v-if="isEdit">{{ detail.sourceStr || '-' }}</span>
          <span v-else-if="type == 1">从衣加加认证企业中同步</span>
          <el-select v-else v-model="createForm.resource" placeholder="请选择" size="small">
            <el-option
              v-for="item in resourceData"
              :key="item.categoryId"
              :label="item.categoryName"
              :value="item.categoryId"
            >
            </el-option>
          </el-select>
          
        </el-form-item>
        <el-form-item
          v-if="type === 1 || isEdit"
          label="注册衣加加ID：" 
        >
          <span v-if="isEdit">{{ fzzhtMemberInfo.userId || '无' }}</span>
          <span v-if="type === 1">{{ companyInfo.user_id || '-' }}</span>
        </el-form-item>
        <el-form-item label="联系人姓名：">
          <el-input
            size="small"
            v-model="createForm.contactName"
            placeholder="请输入联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别：">
          <el-input
            size="small"
            v-model="createForm.sex"
            placeholder="请输入性别"
          ></el-input>
        </el-form-item>
        <el-form-item label="职位：">
          <el-input
            size="small"
            v-model="createForm.job"
            placeholder="请输入职位"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号：">
          <el-input
            size="small"
            v-model="createForm.contactTel"
            placeholder="请输入联系人手机号"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <div class="mod-bar">主体介绍：</div>
    <el-form-item label-width="0">
      <editor2 v-model="createForm.introduction" :dataLoaded="editorDataLoaded" />
    </el-form-item>

    <div class="mod-bar">颁发证书类型：</div>
      <el-form-item 
          label-width="0"
          prop="certificateTypes"
          :rules="[
            { validator: validCertifcates, trigger: 'change' }
          ]"
        >
      <div class="cer-type-list" v-for="(item) in createForm.certificateTypes" :key="item.categoryId">
          <div class="item">
            <span class="col">
              {{item.categoryName}}：
              <el-checkbox :disabled="item.categoryName === DEFAULT_CERTIFICATE_NAME || item.notEdited" v-model="item.checked"></el-checkbox>
            </span>
            <span class="col">
              证书类型显示文字：{{item.children && item.children[0] && item.children[0].displayName || '-'}}
            </span>
            <span class="col">
              会员级别：
              <el-select v-model="item.levelId" placeholder="请选择" size="small">
                <el-option
                  v-for="ele in item.children"
                  :key="ele.categoryId"
                  :label="ele.categoryName"
                  :value="ele.categoryId"
                ></el-option>
              </el-select>
            </span>
            <span class="col">
              会员级别显示文字：
              <el-select v-model="item.levelId" placeholder="请选择" size="small">
                <el-option
                  v-for="ele in item.children"
                  :key="ele.categoryId"
                  :label="ele.displayText"
                  :value="ele.categoryId"
                ></el-option>
              </el-select>
            </span>
            <span class="col">
              类目等级：
              <el-select v-model="item.bizLevel_id_name" placeholder="请选择" size="small">
                <el-option
                  v-for="ele in businessGradeData"
                  :key="ele.categoryId"
                  :label="ele.categoryName"
                  :value="ele.categoryId + ',' + ele.categoryName"
                >
                </el-option>
              </el-select>
            </span>
            <span class="col">
              类目类型：
              <el-select v-model="item.bizType_id_name" placeholder="请选择" size="small">
                <el-option
                  v-for="ele in businessTypeData"
                  :key="ele.categoryId"
                  :label="ele.categoryName"
                  :value="ele.categoryId + ',' + ele.categoryName"
                >
                </el-option>
              </el-select>
            </span>
            <span class="col">
              入会时间：
              <el-date-picker
                :disabled="item.notEdited"
                v-model="item.date"
                size="small"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </span>
            <span class="col">
              前台是否可查询：<el-checkbox v-model="item.queryChecked"></el-checkbox>
            </span>
          </div>
        
      </div>
    </el-form-item>
    
    <div class="bottom-btns-wrap">
      <el-button @click="$emit('cancel')">取消</el-button>
      <!-- <el-button class="btn-large" type="primary" @click="confirmHandle">{{ isEdit ? '确认修改' : '确认颁发'}}</el-button> -->
      <el-button class="btn-large" type="primary" @click="openPreviewDialog">预览</el-button>
    </div>
  </el-form>

  <!-- 预览 -->
  <el-dialog title="预览" :visible.sync="previewVisible" width="1000px" center>
    <div class="preview-detail">
      <h3>主体名称：{{ createForm.subjectName || '-'}}</h3>
        <div class="props-wrap">
          <span class="item">主体类型：{{ previewDetail.subjectTypeStr || '-' }}</span>
          <span class="item">来源：{{ previewDetail.resourceStr || '-' }}</span>
          <span class="item">营业执照号：{{ createForm.businessLicenseNumber || '-' }}</span>
          <span class="item" v-if="type === 1">注册衣加加ID：{{ fzzhtMemberInfo.userId || '无' }}</span>
          <span class="item">主体/负责人身份证：{{ createForm.idNumber || '-' }}</span>
          <span class="item">联系人姓名：{{ createForm.contactName || '-' }}</span>
          <span class="item" v-if="type === 1">注册手机号：{{ fzzhtMemberInfo.registerMobileNumber || '无' }}</span>
          <span class="item">性 别：{{ createForm.sex || '-' }}</span>
          <span class="item">商品标签：{{ createForm.goodsTag || '-' }}</span>
          <span class="item">职 位：{{ createForm.job || '-' }}</span>
          <span class="item">业务范围：{{ createForm.businessScope || '-' }}</span>
          <span class="item">联系人手机号：{{ createForm.contactTel || '-' }}</span>
        </div>

        <br>
        <h3>主体介绍：</h3>
        <div style="width: 600px">
          <div v-html="createForm.introduction"></div>
        </div>
        <br>
        <h3>已颁发证书：</h3>
        <div class="certificate-type-item" v-for="item in fzzhtMemberCertificates" :key="item.id">
          <div class="info">
            {{ item.type }}：已生成  &nbsp;&nbsp;&nbsp;
            证书编号：{{ item.number || '-' }} &nbsp;&nbsp;&nbsp;
            会员级别：{{ item.level }} &nbsp;&nbsp;&nbsp;
            入会时间：{{ item.joinDate }} &nbsp;&nbsp;&nbsp;
            前台是否可查询：{{ item.status === 1 ? '可查询' : '不可查询' }}
          </div>
          <div class="img">
            <canvas style="width: 800px; display:block;" :id="'canvas-' + item.levelId + '-' + item.typeId"></canvas>
          </div>
        </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirmHandle">{{ isEdit ? '确认修改' : '确认颁发'}}</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import { request, api } from '@/common/request_course.js';
import editor2 from "@/components/Editor2"
import { buildThumborUrl } from '@/common/tool.js'
import { Loading } from 'element-ui'
import { utils } from "@/common/common.js";
import { DEFAULT_CERTIFICATE_NAME, YSWL_CERTIFICATE_NAME, YJJ_SOURCE_NAME, COMPANY_TYPE_NAME } from "../util/constant.js";
export default {
  computed: {
    adminId() {
      return utils.getAdminId()
    },
  },
  components: {
    editor2
  },
  props: {
    isEdit: {
      type: Boolean
    },
    type: {  // 1 - 从衣加加认证企业中同步  2 - 独立颁发证书
      type: [Number, String]
    },
    companyInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      DEFAULT_CERTIFICATE_NAME,
      YSWL_CERTIFICATE_NAME,
      // 主体类型列表
      subjectTypeData: [],
      // 来源列表
      resourceData: [],
      // 证书类型列表
      certificateTypesData: [],
      // 类目/业务等级
      businessGradeData: [],
      // 类目/业务类型
      businessTypeData: [],

      // 表单数据
      createForm: {
        subjectName: '',
        subjectType: '',
        resource: '',
        businessLicenseNumber: '',
        idNumber: '',
        goodsTag: '',
        businessScope: '',
        contactName: '',
        sex: '',
        job: '',
        contactTel: '',
        introduction: '',
        certificateTypes: [],
        id: undefined,
        companyId: undefined,
        userId: undefined,
        registerMobileNumber: undefined
      },

      // 详情数据
      detail: {},
      fzzhtMemberInfo: {},
      fzzhtMemberCertificateList: [],
      // 富文本编辑器是否已获取到数据
      editorDataLoaded: false,

      // 预览
      previewVisible: false,
      previewDetail: {},
      fzzhtMemberCertificates: [], // 勾选提交的会员证书
    }
  },
  created() {
    Promise.all([
      this.getSubjectTypeList(),
      this.getResourceList(),
      this.getCerTypeList(),
      this.getBusinessGradeList(),
      this.getBusinessTypeList(),
    ]).then(() => {

      if (this.isEdit) {
        this.getDetail()
      }
    })
  },
  watch: {
    type: {
      handler: function(newValue) {
        console.log('newValue', newValue)
        if (newValue == 1) {
          this.createForm.subjectName = this.companyInfo.company_name
          this.createForm.businessLicenseNumber = this.companyInfo.company_license_number
          this.createForm.companyId = this.companyInfo.company_id
          this.createForm.userId = this.companyInfo.user_id
          this.createForm.registerMobileNumber = this.companyInfo.user_cellphone
        }
      },
      immediate: true
    }
     
  },
  methods: {
    getDetail() {
      let loadingInstance = Loading.service({
        text: '正在加载数据...'
      });
      request({
        url: api.baseUrl + "/certificate/fzzht-member-info/detail",
        method: "get",
        params: {
          id: this.$route.query.id
        }
      }).then(res => {
        loadingInstance.close()
        console.log(res)
        if (res.erroyCode == 200) {
          this.detail = res.data
          this.fzzhtMemberInfo = { ...res.data.fzzhtMemberInfo }
          this.fzzhtMemberCertificateList = [...res.data.fzzhtMemberCertificateList]
          this.createForm.id = this.fzzhtMemberInfo.id
          this.createForm.userId = this.fzzhtMemberInfo.userId
          this.createForm.companyId = this.fzzhtMemberInfo.companyId
          this.createForm.registerMobileNumber = this.fzzhtMemberInfo.registerMobileNumber
          this.createForm.subjectName = this.fzzhtMemberInfo.principalName
          this.createForm.subjectType = this.fzzhtMemberInfo.principalType
          this.createForm.resource = this.fzzhtMemberInfo.source
          this.createForm.businessLicenseNumber = this.fzzhtMemberInfo.businessLicenseNo
          this.createForm.idNumber = this.fzzhtMemberInfo.responsiblePersonIdNumber
          this.createForm.goodsTag = this.fzzhtMemberInfo.productLabel
          this.createForm.businessScope = this.fzzhtMemberInfo.businessScope
          this.createForm.contactName = this.fzzhtMemberInfo.contactName
          this.createForm.sex = this.fzzhtMemberInfo.gender
          this.createForm.job = this.fzzhtMemberInfo.position
          this.createForm.contactTel = this.fzzhtMemberInfo.contactPhoneNumber
          this.createForm.introduction = this.fzzhtMemberInfo.desc
          this.editorDataLoaded = true

          this.createForm.certificateTypes = this.createForm.certificateTypes.map(item => {
            let cur = this.fzzhtMemberCertificateList.find(ele => ele.typeId === item.categoryId)
            if (cur) {
              return ({
                ...item,
                checked: true,
                levelId: cur.levelId,
                date: cur.joinDate,
                queryChecked: cur.status === 1 ? true : false,
                notEdited: true,
                id: cur.id,
                number: cur.number,
                memberId: cur.memberId,
                bizLevel_id_name: cur.bizLevelId ? cur.bizLevelId + ',' + cur.bizLevel : '无,无', 
                bizType_id_name: cur.bizTypeId ? cur.bizTypeId + ',' + cur.bizType : '无,无',
              })
            }
            return item
          })

          
          /* {
            certificateTypes: []
          },
          */
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取主体类型列表
    getSubjectTypeList() {
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20201'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.subjectTypeData = res.data
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    // 获取来源列表
    getResourceList() {
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20202'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          if (res.data) {
            this.resourceData = res.data.filter(item => item.categoryName !== '从衣加加认证企业中同步')
          } 
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    // 获取证书类型列表
    getCerTypeList() {
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20203'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.certificateTypesData = res.data.map(item => {
            return ({
              ...item,
              children: item.children.map(ele => ({
                ...ele,
                showUrl: buildThumborUrl(ele.certificateImage, {width: 1263, height: 893})
              }))
            })
          })
          this.createForm.certificateTypes = this.certificateTypesData.map(item => {
            return ({
              ...item,
              checked: item.categoryName === DEFAULT_CERTIFICATE_NAME ? true : false,
              levelId: '',
              date: '',
              queryChecked: false,
              bizLevel_id_name: '无,无',
              // bizLevelId: '',
              // bizLevel: '',
              bizType_id_name: '无,无',
              // bizTypeId: '',
              // bizType: '',
            })
          }) 
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    // 获取类目/业务等级
    getBusinessGradeList() {
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20204'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.businessGradeData = [
            {
              categoryId: '无',
              categoryName: '无',
              categoryStatus: "y",
              categoryType: 20204,
              children: [],
              parentId: 0
            }].concat(res.data)
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    // 获取类目/业务类型
    getBusinessTypeList() {
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20205'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.businessTypeData = [
            {
              categoryId: '无',
              categoryName: '无',
              categoryStatus: "y",
              categoryType: 20205,
              children: [],
              parentId: 0
            }].concat(res.data)
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    confirmHandle() {
      console.log(this.createForm)
      this.$emit('confirm', { form: this.createForm, fzzhtMemberCertificates: this.fzzhtMemberCertificates  })
    },
    // 打开预览弹框
    openPreviewDialog() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          if (this.type == 1) {
            // this.createForm.companyId = this.companyInfo.company_id
            // this.createForm.userId = this.companyInfo.user_id
            // this.createForm.registerMobileNumber = this.companyInfo.user_cellphone
            let subjectTypeObj = this.subjectTypeData.find(item => item.categoryName === COMPANY_TYPE_NAME)
            if (!subjectTypeObj) return this.$message.error('主体类型缺少“' + COMPANY_TYPE_NAME + '”配置项')
            this.createForm.subjectType = subjectTypeObj.categoryId

            let resourceObj = this.resourceData.find(item => item.categoryName === YJJ_SOURCE_NAME)
            if (!resourceObj) return this.$message.error('来源缺少“' + YJJ_SOURCE_NAME + '”配置项')
            this.createForm.resource = resourceObj.categoryId
          } 

          // let checkedArr = this.createForm.certificateTypes.filter(item => item.checked)
          // if (checkedArr.length === 0) return this.$message.error('请至少勾选一个证书')

          this.previewVisible = true

          let subjectTypeObj = this.subjectTypeData.find(item => item.categoryId === this.createForm.subjectType)
          if (subjectTypeObj) {
            this.previewDetail.subjectTypeStr = subjectTypeObj.categoryName
          }
          let resourceObj = this.resourceData.find(item => item.categoryId === this.createForm.resource)
          if (resourceObj) {
            this.previewDetail.resourceStr = resourceObj.categoryName
          }

          let selectedCertificateTypes = this.createForm.certificateTypes
            .filter(item => item.checked)

          let cerNumberRes
          try {
            cerNumberRes = await this.getCertificateNumber()
          } catch (error) {
            console.log('error', error)
          }

          let fzzhtNumber 
          let fzzhtNumberObj = selectedCertificateTypes.find(item => !!item.number)
          if (fzzhtNumberObj) fzzhtNumber = fzzhtNumberObj.number

          this.fzzhtMemberCertificates = await Promise.all(selectedCertificateTypes.map(async item => {
              let cerNumber
              if (item.categoryName == DEFAULT_CERTIFICATE_NAME || item.categoryName == YSWL_CERTIFICATE_NAME) {
                if (fzzhtNumber) {
                  cerNumber = fzzhtNumber
                } else {
                  cerNumber = cerNumberRes.data
                }
              }

              let bizLevelArr = item.bizLevel_id_name == '无,无' ? [] : item.bizLevel_id_name.split(',')
              let bizTypeArr = item.bizType_id_name == '无,无' ? [] : item.bizType_id_name.split(',')

              if (!this.isEdit) {
                return ({
                  createBy: this.adminId,
                  joinDate: item.date,
                  level: item.children.find(c => c.categoryId === item.levelId).categoryName,
                  levelId: item.levelId,
                  member: this.createForm.subjectName,
                  number: cerNumber || undefined,
                  status: item.queryChecked ? 1 : 0,
                  type: item.categoryName,
                  typeId: item.categoryId,
                  showUrl: item.children.find(ele => ele.categoryId === item.levelId).showUrl,
                  displayName: item.children.find(c => c.categoryId === item.levelId).displayName,
                  displayText: item.children.find(c => c.categoryId === item.levelId).displayText,
                  bizLevelId: bizLevelArr[0],
                  bizLevel: bizLevelArr[1],
                  bizTypeId: bizTypeArr[0],
                  bizType: bizTypeArr[1],
                })
              } else {
                return ({
                  [item.id ? 'lastUpdateBy' : 'createBy']: this.adminId,
                  joinDate: item.date,
                  level: item.children.filter(c => c.categoryId === item.levelId)[0].categoryName,
                  levelId: item.levelId,
                  member: this.createForm.subjectName,
                  number: cerNumber || undefined,
                  status: item.queryChecked ? 1 : 0,
                  type: item.categoryName,
                  typeId: item.categoryId,
                  id: item.id || undefined,
                  memberId: this.createForm.id || undefined,
                  showUrl: item.children.find(ele => ele.categoryId === item.levelId).showUrl,
                  displayName: item.children.find(c => c.categoryId === item.levelId).displayName,
                  displayText: item.children.find(c => c.categoryId === item.levelId).displayText,
                  bizLevelId: bizLevelArr[0],
                  bizLevel: bizLevelArr[1],
                  bizTypeId: bizTypeArr[0],
                  bizType: bizTypeArr[1],
                })
              }
            })
          )
          console.log('fzzhtMemberCertificates', this.fzzhtMemberCertificates)

          this.$nextTick(() => {
            this.fzzhtMemberCertificates.forEach(item => {
              let canvas = document.getElementById('canvas-'  + item.levelId + '-' + item.typeId);
              canvas.width = 1263; 
              canvas.height = 893;
              let context = canvas.getContext('2d');
              let image = new Image()
              let imgUrl = item.showUrl
              if (imgUrl) {
                image.src = imgUrl
                console.log('imgUrl', imgUrl)
                image.onload = function(){
                  context.drawImage(image, 0, 0, 1263, 893)

                  let companyTitle = item.member || ''
                  let titleLength = companyTitle.length;
                  let fontSize = 40;
                  if (titleLength > 16) fontSize = 32
                  if (titleLength > 24) fontSize = 24
                  if (titleLength > 32) fontSize = 20
                  context.font = "bold " + fontSize + "px KaiTi,STKaiti";
                  context.textAlign="center";
                  context.fillStyle="#000000";
                  context.fillText(companyTitle, 442, 180);

                  if (item.number) {
                    context.font = "18px SimSun";
                    context.textAlign="start";
                    context.fillStyle="#000000";
                    context.fillText('No:' + item.number, 82, 64);
                  }

                  if (item.displayName) {
                    context.font = "bold 68px SimSun";
                    context.textAlign="center";
                    context.fillStyle="#e50021";
                    context.fillText(item.displayName, 442, 390);
                  }

                  if (item.displayText) {
                    context.font = "bold 68px SimSun";
                    context.textAlign="center";
                    context.fillStyle="#e50021";
                    context.fillText(item.displayText, 442, 478);
                  }

                  let level_type = ''
                  if (item.bizLevel) {
                    level_type += item.bizLevel + ':'
                  }
                  if (item.bizType) {
                    level_type += item.bizType
                  }

                  if (level_type) {
                    context.font = "bold 28px SimSun";
                    context.textAlign="start";
                    context.fillStyle="#e50021";
                    context.fillText(level_type, 925, 150);
                  }
                  
                }
              } else {
                context.font = "36px KaiTi,STKaiti";
                context.textAlign="center";
                context.fillStyle="#000000";
                context.fillText('暂无证书模板， 无法生成预览图', 632, 446);
              }
              
            })
          })
        }
      })
    },
    // 获取证书
    getCertificateNumber() {
      return request({
        url: api.baseUrl + "/certificate/fzzht-member-certificate/getCertificateNumber",
        method: "get",
      })
    },
    validCertifcates(rule, value, callback) {
      let checkedArr = this.createForm.certificateTypes.filter(item => item.checked)
      if (checkedArr.length === 0) return callback(new Error('请至少勾选一个证书'))
      if (checkedArr.some(item => (!item.levelId))) {
        return callback(new Error('已勾选的证书，请选择会员级别'))
      }
      if (checkedArr.some(item => (!item.date))) {
        return callback(new Error('已勾选的证书，请选择入会时间'))
      }
      callback()
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-bar {
  font-size: 16px;
  margin-bottom: 16px;
}
.cer-type-list {
  .item {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px dashed #ccc;
  }
  .col {
    width: 48%;
    display: inline-block;
  }
}
.bottom-btns-wrap {
  padding: 40px 0 60px;
  text-align: center;
  .btn-large {
    padding-left: 80px;
    padding-right: 80px;
  }
}
.preview-detail {
  .props-wrap {
    width: 1000px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 50%;
      margin-bottom: 16px;
    }
  }
  .certificate-type-item {
    margin-bottom: 36px;
    .img {
      margin-top: 16px;
      border: 1px solid #eee;
      width: 800px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/certificate/component/createForm.vue